import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { PrivateAxios } from "../api";


export const fetchOrderById = createAsyncThunk(
  "order/fetchOrderById",
  async (orderId, { rejectWithValue }) => {
    try {
      const response = await PrivateAxios.get(`/api/user/order/show?order_id=${orderId}`, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.data.status) {
        return rejectWithValue(response.data.message || "Invalid code.");
      }

      return response.data.data.order;
    } catch (error) {
      console.error("Error fetching order:", error.message);
      return rejectWithValue(
        error.response?.data || error.request || "Failed to fetch order"
      );
    }
  }
);


const initialState = {
  order: null,
  status: "idle",
  error: null,
};

const ShowOrderIdSlice = createSlice({
  name: "order",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchOrderById.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchOrderById.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.order = action.payload;
      })
      .addCase(fetchOrderById.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export default ShowOrderIdSlice.reducer;